module.exports = __webpack_public_path__ + "public/img/coupon.6bf4f386.png";